import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import ChildrenEntities from 'client/components/core/ChildrenEntities'
import { ContentWidthEnum } from 'common/types/styleTypes'
import React from 'react'
import { CommonWebsiteFooter } from 'src/shared/entities/website-footer'
import { WebsiteFooterInterface } from 'src/shared/types/website-entities'
import { getBackgroundImageStyleValue } from 'src/shared/utils/get-background-style-by-file'
import { useThemeColor } from '../../hooks/use-theme-color'

export interface WebsiteFooterProps {
  entity: WebsiteFooterInterface
  isMoveUpAllowed: boolean
  isMoveDownAllowed: boolean
}

export const WebsiteFooter = ({ entity }: WebsiteFooterProps) => {
  const { headerAndFooter } = useThemeColor()

  const backgroundImage = getBackgroundImageStyleValue(
    headerAndFooter?.footerBackgroundPicture.file,
  )

  return (
    <BaseEntityNew
      entity={entity}
      isMoveUpAllowed={false}
      isMoveDownAllowed={false}
      isSaveAllowed={false}
      isRemoveAllowed={false}
      isCopyAllowed={false}
      isMoveAllowed={false}
      appearance={{ mobile: true, desktop: true }}
    >
      <CommonWebsiteFooter
        htmlAttrId={entity.htmlAttrId}
        backgroundImage={backgroundImage}
        background={headerAndFooter?.footerBackgroundPicture.background}
        backgroundColor={headerAndFooter?.footerBackgroundColor}
        border={entity.border}
        mobileBorder={entity.mobileBorder}
        padding={entity.padding}
        mobilePadding={entity.mobilePadding}
        contentWidth={entity.contentWidth || ContentWidthEnum.m}
      >
        <ChildrenEntities
          id={entity.id}
          childIds={entity.childIds}
          type={entity.type}
        />
      </CommonWebsiteFooter>
    </BaseEntityNew>
  )
}
